module.exports = __webpack_public_path__ + "static/media/signupSlider.b71c5a8d.png";